<template>
  <div>
    <div class="configurator box-outline mb-2">
      <div class="box-title">
        <h3>Válassza ki a futamidőt és a km futást</h3>
      </div>
      <div class="box-content">
        <contract-length-selector :lead="lead" />
        <annual-mileages-selector :lead="lead" />
        <initial-payment-selector />
      </div>
    </div>

    <div class="box info-box tartalmazza-list mt-3">
      <div class="box-content">
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'Futamidő alatt fix kamatozású, forint alapú finanszírozás.' }"></i>Fix HUF finanszírozás</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'Teljeskörű karbantartás - kötelező szervizek és kopóforgó alkatrészek cseréje mellett minden, normál használat mellett felmerülő javítást tartalmaz.' }"></i>Karbantartás, szerviz</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'Tervezett futásnak megfelelő mennyiségű téli-nyári gumiabroncs beszerzése, tárolása, szezonális cseréje.' }"></i>Téli-nyári gumi</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'A kötelező gépjárműbiztosítás és casco mellett GAP könyvértékbiztosítást is tartalmaz.' }"></i>Biztosítások (KGFB, Casco, GAP)</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'Gépjármű- és cégautóadót a bérleti díj tartalmazza.' }"></i>Gépjármű- és cégautóadó</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
        <div class="row box-row">
          <div class="col box-label"><i class="fas fa-info-circle service-info-icon" tabindex="0" v-b-tooltip.hover.focus.right="{ customClass: 'service-tooltip', title: 'Meghibásodás és baleset esetén műszaki segítségnyújtást, autómentést és csereautót tartalmaz Magyarországon és az EU-ban.' }"></i>Európai assistance</div>
          <div class="col-auto box-value">Tartalmazza</div>
        </div>
      </div>
    </div>

    <template v-if="showOffer">
      <div class="configurator box-outline mt-3">
        <div class="box-footer">
          <span>Bérleti díj:</span>
          <h5 v-if="calculatedPrice">{{ calculatedPrice | currency }} Ft + ÁFA / hó</h5>
          <h5 v-else>Hívjon bennünket!</h5>
          <hr>
          <div class="text-right">
            <span>Induló bérleti díj:</span>
            <h6 v-if="calculatedPrice">{{ initialPayment | currency }} Ft + ÁFA</h6>
            <h6 v-else>Hívjon bennünket!</h6>
          </div>
        </div>
      </div>
      <div class="offer-contact text-center mt-2">
        <a href="tel:+3618880088" class="offer-phone d-block mb-1"><i class="fas fa-phone mr-1"></i>Hívjon: +36 1 888 0088</a>
        <a href="#" @click.prevent="$bvModal.show('configuratorCallbackModal')" class="offer-callback d-block">Kérjen visszahívást!</a>
      </div>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
  import ContractLengthSelector from './Configurator/ContractLengthSelector';
  import AnnualMileagesSelector from './Configurator/AnnualMileagesSelector';
  import InitialPaymentSelector from './Configurator/InitialPaymentSelector';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {InitialPaymentSelector, AnnualMileagesSelector, ContractLengthSelector}
  })
  export default class ConfiguratorCalculator extends Vue {
    @configuratorModule.Action('initialize') initialize;
    @configuratorModule.Action('loadLead') loadLead;
    @configuratorModule.Getter('getCalculatedPrice') calculatedPrice;
    @configuratorModule.Getter('getInitialPayment') initialPayment;

    @Prop(String) typeId;
    @Prop(Number) m;
    @Prop(Number) k;
    @Prop(Number) prinp2;
    @Prop(Object) prices;
    @Prop(Object) lead;
    @Prop(Boolean) userLogged;
    @Prop(String) currentLeadId;
    @Prop({ type: Boolean, default: true }) init;
    @Prop({ type: Boolean, default: false }) showOffer;

    created() {
      if (this.init) {
        this.initialize({
          typeId: this.typeId,
          prices: this.prices,
          prinp2: this.prinp2,
          m: this.m,
          k: this.k,
          currentLeadId: this.currentLeadId
        });

        if (this.lead) {
          this.loadLead(this.lead);
        }
      }
    }
  }
</script>

<style scoped>
/* Services (Tartalmazza) kept on one line at all breakpoints; gray style unchanged. */
.tartalmazza-list .box-row {
  flex-wrap: nowrap;
  align-items: center;
  font-size: 0.85rem;
}
/* label must be the shrinkable column so a long label (Biztosítások …) wraps instead of squashing the value */
.tartalmazza-list .box-label {
  min-width: 0;
}
.tartalmazza-list .box-value {
  white-space: nowrap;
  padding-left: 10px;
}
.tartalmazza-list .service-info-icon {
  color: #03679A;
  margin-right: 5px;
  font-size: 0.9em;
  cursor: help;
}
</style>
